module.exports = __webpack_public_path__ + "44b1dc330b693184250b3d4aa79639ef.png";